// Lib
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { avgOutboundClickRatePerPinConfig } from '@/lib/analytics/kpis/pinterest/avgOutboundClickRatePerPin';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerOutboundClickRateConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof KPIDefault
> = {
    ...avgOutboundClickRatePerPinConfig,
    id: 'outbound_click_rate',
    size: SIZE_50,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
